"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var Icon_1 = __importDefault(require("./Icon"));
exports.Icon = Icon_1.default;